import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export type DftReviewFileData = {
  taxAmount: number;
  grossAssetValue: number;
  file: {
    download_url: string;
    preview_url: string;
    uuid: string;
  };
  groupId: string;
} | null;

const initialState = null as DftReviewFileData;

export const dftFilingDraftReview = createSlice({
  name: "dftFilingDraftReview",
  initialState,
  reducers: {
    setDftDraftForReview: (
      _state,
      action: PayloadAction<DftReviewFileData | null>
    ) => {
      return action.payload;
    },
    resetDftDraftForReview: () => {
      return null;
    },
  },
});

export const { setDftDraftForReview, resetDftDraftForReview } =
  dftFilingDraftReview.actions;

export default dftFilingDraftReview.reducer;
